@if (responsiveService.mobile()) {
    <woa-full-page-layout class="mobile-page"
                          [ngClass]="{'order-view': viewingOrder()}"
                          [hideBackButton]="!viewingMobileView()"
                          [showNavbarLogo]="viewingOrder() || !viewingMenuItems()"
                          [navbarTitle]="!viewingOrder() && viewingMenuItems() ? 'woa.heading.item-selection.title' : undefined"
                          [translationParams]="{categoryName: menuModel.getCategoryDisplayName()(menuModel.selectedCategory())}"
                          [pillarboxedOnMobile]="'none'" [showFooter]="showMobileFooter()"
                          [enableSwipeRefresh]="true"
                          (onRefresh)="requestReload('user refresh', true, true, true, true)">
        @if (showMobileNavMenuIcon()) {
            <woa-icon-button slot="navbar-left"
                             [type]="IconButtonType.MENU" [disabled]="!isLoaded()"
                             (onActivate)="navigationService.createPage('woa-nav-menu-page', undefined, {alignment: PageAlignment.LEFT})"></woa-icon-button>
        }
        <woa-icon-button slot="navbar-right" [type]="IconButtonType.SEARCH" [disabled]="!isLoaded()" [enlarged]="true"
                         (onActivate)="searchMenu()"></woa-icon-button>
        @if (showOrderSummaryIcon()) {
            <woa-order-summary-icon slot="navbar-right"
                                    (onOrderSummary)="viewOrder()"></woa-order-summary-icon>
        }
        @if (loadingStatus() === LoadingStatus.FAILED) {
            <woa-content-message [level]="MessageLevel.ERROR"
                                 [text]="'woa.error.common.loadFailed'" [link]="'woa.button.common.reload'"
                                 (onLinkActivate)="requestReload('failure reload', true, true, false, true)"></woa-content-message>
        }
        @if (viewingOrder() && orderModel.orderInitiationStatus() === OrderInitiationStatus.FAILED && orderModel.initiationErrorKey()) {
            <woa-content-message [level]="MessageLevel.ERROR"
                                 [text]="orderModel.initiationErrorKey()" [link]="'woa.button.common.retry'"
                                 [translationParams]="orderModel.initiationErrorParams()"
                                 (onLinkActivate)="orderModel.requestOrderInitiation('ordering page - initiation error retry')"></woa-content-message>
        }
        @if (showOrderingContextPanel()) {
            <woa-ordering-context-panel class="mobile-page-ordering-context"></woa-ordering-context-panel>
        }
        @if (showCarousel()) {
            <woa-promo-carousel class="mobile-page-promo-carousel"
                                [nrVisibleSlides]="nrVisibleSlides()"
                                [deals]="promotedDeals()"
                                [promos]="orderModel.personalOrderStarted() ? triggeredAndUnsuppressedCardPromos() : promotedCardPromos()"
                                [promoteMemberLogin]="true"
                                [morePromotionalCards]="orderModel.personalOrderStarted() ? false : morePromotionalCards()"
                                [showMorePromotionalCardsAsSlide]="true"
                                [autoScrollEnabled]="!configurationModel.noAutoScroll()"
                                (onOrderDeal)="orderDeal($event)"
                                (onPromoActioned)="promoActioned($event.promo, $event.promo.promoCardAction, $event.menuItem)"></woa-promo-carousel>
        }
        @if (showMobileHeaderImage()) {
            <woa-page-header-image class="mobile-page-store-image"></woa-page-header-image>
        }
        @if (viewingOrder()) {
            <woa-order-heading-panel class="mobile-page-order-heading"></woa-order-heading-panel>
        }
        @if (showFeatureButtons()) {
            <woa-feature-button-panel class="mobile-page-feature-buttons" [ngClass]="{'order-view': viewingOrder()}"
                                      [allowShowAppliedDeals]="viewingOrder()"
                                      (onOpenGroupOrder)="groupOrderModel.openGroupOrder()"></woa-feature-button-panel>
        }
        @if (viewingOrder() && orderModel.orderNotes()) {
            <div class="mobile-page-order-notes">
                <woa-content-message [level]="MessageLevel.SUCCESS" [icon]="'pen-circle'"
                                     [linkLayout]="MessageLayout.HORIZONTAL"
                                     [text]="orderModel.orderNotes() | literal">
                    <woa-link [link]="'woa.button.common.edit'" [plain]="true"
                              (onActivate)="orderModel.editNotes()"></woa-link>
                    <woa-link [link]="'woa.button.common.remove'" [plain]="true"
                              (onActivate)="orderModel.removeNotes()"></woa-link>
                </woa-content-message>
            </div>
        }
        @if (viewingOrder()) {
            <woa-order-edit-panel class="mobile-page-order" [showRetry]="false"></woa-order-edit-panel>
        } @else {
            @if (showMenu()) {
                @if (viewingMenuItems()) {
                    <woa-menu-subcategory-anchor-panel class="mobile-page-menu-subcategory-anchors"
                                                       #anchorPanel></woa-menu-subcategory-anchor-panel>
                    <woa-menu-item-selection-panel class="mobile-page-menu-items"
                                                   [anchorPanel]="anchorPanelER()"
                                                   [pageScroller]="pageLayout()?.pageScrollerER()"
                                                   (onBack)="navigationService.dismissView()"></woa-menu-item-selection-panel>
                } @else {
                    <woa-menu-category-selection-panel class="mobile-page-menu-categories"></woa-menu-category-selection-panel>
                }
            }
            <div class="mobile-page-footer">
                @if (isLoaded() && configurationModel.app()?.dietaryStatement && configurationModel.isConsumerActor()) {
                    <woa-content-message [level]="MessageLevel.INFO"
                                         [text]="configurationModel.app()?.dietaryStatement | literal"></woa-content-message>
                }
                <div class="mobile-page-footer-logo">
                    <woa-chewzie-attribution></woa-chewzie-attribution>
                </div>
            </div>
        }
        <woa-order-errors-panel slot="footer-messages"></woa-order-errors-panel>
        @if (configurationModel.isWaiterActor() && menuModel.rsaBlocked()) {
            <woa-footer-message class="rsa-notice" [level]="MessageLevel.WARNING" [icon]="'no-alcohol'"
                                [text]="'woa.message.order.rsaBlocked'"
                                [translationParams]="{
                                    'tableNumber': this.orderingContextModel.currentTableNumberLabel()
                                }"
                                (onActivate)="menuModel.setRsaBlock()"></woa-footer-message>
        }
        @if (waitTimeNotice()) {
            <woa-footer-message [level]="MessageLevel.WARNING" [icon]="'clock-three'" [text]="waitTimeNotice()"
                                [translationParams]="{
                                    'category': menuModel.getCategoryDisplayName()(menuModel.selectedCategory()),
                                    'venueWaitTime': orderingContextModel.venueWaitTime(),
                                    'categoryWaitTime': menuModel.selectedCategoryWaitTime()
                                }"></woa-footer-message>
        }
        @if (isLoaded() && groupOrderModel.showGroupOrderNotice()) {
            <woa-footer-message class="group-order-notice"
                                [level]="MessageLevel.SUCCESS" [showIcon]="false"
                                [text]="'woa.message.order.groupOrderNotice'" [actionable]="true"
                                (onActivate)="groupOrderModel.openGroupOrder()">
                <woa-group-order-summary-icon></woa-group-order-summary-icon>
            </woa-footer-message>
        }
        @if (viewingOrder() && orderingContextModel.showMarketingOptIn() && paymentModel.showQuickPay()) {
            <woa-selector-control slot="footer-start" class="marketing-opt-in" [label]="'woa.label.common.marketingOptIn'"
                                  [(selected)]="orderingContextModel.marketingOptIn"></woa-selector-control>
        }
        @if (viewingOrder() && isLoaded() && orderModel.orderHasItems()) {
            <woa-order-totals-panel slot="footer-start" class="totals"></woa-order-totals-panel>
        } @else if (!viewingOrder() && isLoaded() && orderModel.orderHasItems()) {
            <woa-button woa-page-footer-control
                        [label]="'woa.button.order.view'"
                        [translationParams]="{items: orderModel.totalItems()}"
                        (onActivate)="viewOrder()"></woa-button>
        }
        @if (viewingOrder()) {
            <woa-button woa-page-footer-control [label]="otherPayLabel()"
                        [prominence]="otherPayProminence()"
                        [showSpinner]="checkoutPending()"
                        [disabled]="checkoutPending() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                        (onActivate)="checkout()"></woa-button>
        }
        @if (viewingOrder() && paymentModel.showQuickPay()) {
            <woa-quick-pay-panel woa-page-footer-control
                                 [showSpinner]="checkoutPending()" [disabled]="checkoutPending()"
                                 (pay)="quickPay($event)"></woa-quick-pay-panel>
        }
        @if (viewingOrder() && paymentModel.showQuickPay()) {
            <woa-legal-panel slot="footer-end" class="mobile-page-payment-legal"
                             [messageSet]="'payment'"></woa-legal-panel>
        }
    </woa-full-page-layout>
}
@if (responsiveService.desktop()) {
    <woa-desktop-home-page-layout #desktopHomePage class="desktop-page"
                                  [enableNavMenuIcon]="loadingStatus() === LoadingStatus.LOADED || loadingStatus() === LoadingStatus.RELOADING"
                                  (onRefresh)="requestReload('user refresh',true, true, true, true)"
                                  (onSearchMenu)="searchMenu()"
                                  [woa-background-image]="[{
                                      conditional: true,
                                      on: !menuModel.showItemImages()(undefined),
                                      image: menuModel.pageImage(),
                                      opacity: menuModel.pageImageOpacity(),
                                      tiled: true,
                                      classes: 'menu-page-image-color-pair',
                                      cssVars: {'--woa-desktop-menu-image-applied': true}
                                  }, {
                                      classes: 'theme-standard-page-color-pair',
                                      conditional: false
                                  }]">
        @if (loadingStatus() === LoadingStatus.FAILED) {
            <woa-content-message [level]="MessageLevel.ERROR"
                                 [text]="'woa.error.common.loadFailed'" [link]="'woa.button.common.reload'"
                                 (onLinkActivate)="requestReload('failure reload', true, true, false, true)"></woa-content-message>
        }
        <!--suppress JSUnusedGlobalSymbols -->
        @if (showCarousel()) {
            <woa-promo-carousel class="desktop-page-promo-carousel" slot="content-header"
                                [nrVisibleSlides]="nrVisibleSlides()"
                                [deals]="promotedDeals()"
                                [promos]="orderModel.personalOrderStarted() ? triggeredAndUnsuppressedCardPromos() : promotedCardPromos()"
                                [promoteMemberLogin]="true"
                                [morePromotionalCards]="orderModel.personalOrderStarted() ? false : morePromotionalCards()"
                                [showMorePromotionalCardsAsSlide]="false"
                                [autoScrollEnabled]="!configurationModel.noAutoScroll()"
                                (onOrderDeal)="orderDeal($event)"
                                (onPromoActioned)="promoActioned($event.promo, $event.promo.promoCardAction, $event.menuItem)"></woa-promo-carousel>
        }
        @if (showMenu()) {
            <woa-menu-category-selection-panel class="desktop-page-menu-categories" slot="content-selector"
                                               woa-responsive
                                               [showNavIcons]="false"></woa-menu-category-selection-panel>
        }
        <!--suppress JSUnusedGlobalSymbols -->
        <woa-menu-subcategory-anchor-panel class="desktop-page-menu-subcategory-anchors" slot="content-details-header"
                                           #anchorPanel></woa-menu-subcategory-anchor-panel>
        @if (showMenu()) {
            <woa-menu-item-selection-panel class="desktop-page-menu-items" slot="content-details-main"
                                           [anchorPanel]="anchorPanelER()"
                                           [anchorPanelTopMargin]="desktopHomePage.navbarHeight()"
                                           [pageScroller]="desktopHomePage?.scrollerER()"
                                           [showBackButton]="false" [showClosePromoAction]="true"
                                           [alwaysShowCategoryHeader]="true"></woa-menu-item-selection-panel>
        }
        @if (showOrderingContextPanel()) {
            <woa-ordering-context-panel slot="sidebar-header"></woa-ordering-context-panel>
        }
        <woa-order-heading-panel class="desktop-page-order-heading" slot="sidebar-body"></woa-order-heading-panel>
        @if (showFeatureButtons()) {
            <woa-feature-button-panel class="desktop-page-feature-buttons" slot="sidebar-body"
                                      (onOpenGroupOrder)="groupOrderModel.openGroupOrder()"></woa-feature-button-panel>
        }
        @if (orderModel.orderNotes()) {
            <div class="desktop-page-order-notes" slot="sidebar-body">
                <woa-content-message [level]="MessageLevel.SUCCESS" [icon]="'pen-circle'"
                                     [linkLayout]="MessageLayout.HORIZONTAL"
                                     [text]="orderModel.orderNotes() | literal">
                    <woa-link [link]="'woa.button.common.edit'" [plain]="true"
                              (onActivate)="orderModel.editNotes()"></woa-link>
                    <woa-link [link]="'woa.button.common.remove'" [plain]="true"
                              (onActivate)="orderModel.removeNotes()"></woa-link>
                </woa-content-message>
            </div>
        }
        <woa-order-edit-panel class="desktop-page-order" slot="sidebar-body"
                              (onRetry)="orderModel.requestOrderInitiation('ordering page - initiation error retry')"></woa-order-edit-panel>
        <woa-order-errors-panel slot="footer-messages"></woa-order-errors-panel>
        @if (configurationModel.isWaiterActor() && menuModel.rsaBlocked()) {
            <woa-footer-message class="rsa-notice" [level]="MessageLevel.WARNING" [icon]="'no-alcohol'"
                                [text]="'woa.message.order.rsaBlocked'"
                                [translationParams]="{
                                    'tableNumber': this.orderingContextModel.currentTableNumberLabel()
                                }"
                                (onActivate)="menuModel.setRsaBlock()"></woa-footer-message>
        }
        @if (waitTimeNotice()) {
            <woa-footer-message [level]="MessageLevel.WARNING" [icon]="'clock-three'" [text]="waitTimeNotice()"
                                [translationParams]="{
                                    'category': menuModel.getCategoryDisplayName()(menuModel.selectedCategory()),
                                    'venueWaitTime': orderingContextModel.venueWaitTime(),
                                    'categoryWaitTime': menuModel.selectedCategoryWaitTime()
                                }"></woa-footer-message>
        }
        @if (isLoaded() && groupOrderModel.showGroupOrderNotice()) {
            <woa-footer-message class="group-order-notice"
                                [level]="MessageLevel.SUCCESS" [showIcon]="false"
                                [text]="'woa.message.order.groupOrderNotice'" [actionable]="true"
                                (onActivate)="groupOrderModel.openGroupOrder()">
                <woa-group-order-summary-icon></woa-group-order-summary-icon>
            </woa-footer-message>
        }
        @if (isLoaded() && orderModel.orderHasItems()) {
            <woa-order-totals-panel slot="sidebar-footer-start" class="totals"></woa-order-totals-panel>
        }
        @if (isLoaded() && orderModel.orderHasItems()) {
            <woa-button woa-page-footer-control
                        [label]="otherPayLabel()" [prominence]="otherPayProminence()"
                        [showSpinner]="checkoutPending()"
                        [disabled]="checkoutPending() || orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING"
                        (onActivate)="checkout()"></woa-button>
        }
        @if (isLoaded() && orderModel.orderHasItems() && !suppressQuickPay() && paymentModel.showQuickPay()) {
            <woa-quick-pay-panel woa-page-footer-control [showSpinner]="checkoutPending()"
                                 [disabled]="checkoutPending()" (pay)="quickPay($event)"></woa-quick-pay-panel>
        }
        @if (isLoaded() && orderModel.orderHasItems() && paymentModel.showQuickPay()) {
            <woa-legal-panel slot="sidebar-footer-end" class="desktop-page-payment-legal"
                             [messageSet]="'payment'"></woa-legal-panel>
        }
    </woa-desktop-home-page-layout>
}
